import React from 'react';
import '../styles/cta.scss';

import lrLogo from '../assets/rangeRoverLogo.svg';

const Cta = () => {
  return (
    <div className="ctaCont">
      <div className="ctaCont__logo">
        <a href="https://www.landroverusa.com/index.html" target="_blank" rel="sponsored noopener">
          <img src={lrLogo} alt="landrover logo" />
        </a>
      </div>
      <div className="ctaCont__button">
        <a href="https://www.landroverusa.com/index.html" target="_blank" rel="sponsored noopener">
          <button>explore our vehicles</button>
        </a>
      </div>
    </div>
  );
};

export default Cta;
